module.exports = __webpack_public_path__ + "assets/images/logo.8dad5045ce367abe16391242621cc6fb.png";